export default "__VITE_ASSET__BKgTNBb1__"